module.exports = __webpack_public_path__ + "img/solar-panel.c9ac488f.svg";